<template>
  <abstract-autocomplete
    v-model="localValue"
    :chips="chips"
    :clearable="clearable"
    :counter="counter"
    :deletable-chips="deletableChips"
    :dense="dense"
    :disabled="disabled"
    :id-predicate-path="idPredicatePath"
    :item-value="itemValue"
    :label="label"
    :list-api="listApi"
    :multiple="multiple"
    :outlined="outlined"
    :placeholder="placeholder"
    :preload-all-options="preloadAllOptions"
    :query-param="queryParam"
    :return-object="returnObject"
    :rounded="rounded"
    :rules="rules"
    :search-debounce-time="searchDebounceTime"
    :selected-item-to-text="selectedItemToText"
    :shaped="shaped"
    :show-validation="showValidation"
    :single-line="singleLine"
    :small-chips="smallChips"
    :vid="vid"
    @change="$emit('change', $event)"
    @inputObject="$emit('inputObject', $event)"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-item">
        <v-col>Wersja</v-col>
      </slot>
    </template>
    <template v-slot:item="{ data }">
      {{ c(data) }}
      <slot :data="data" name="item">
        <v-col>{{ data.item.label }}</v-col>
      </slot>
    </template>
  </abstract-autocomplete>
</template>

<script>
import AbstractAutocomplete from './abstract/AbstractAutocomplete';
import LocalValueInput from './abstract/LocalValueInput';
import AutocompleteProps from './abstract/AutocompleteProps';

export default {
  components: {AbstractAutocomplete},
  mixins: [LocalValueInput, AutocompleteProps],

  props: {
    value: {
      type: [Number, Object, Array],
      default: null
    },
    queryParam: {
      type: String,
      default: ''
    },
    idPredicatePath: {
      type: String,
      default: 'id'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    preloadAllOptions: {
      type: Boolean,
      default: true
    },
    vid: {
      type: String,
      default: 'data-logger'
    },
    label: {
      type: String,
      default: 'Mikroserwer'
    },
    placeholder: {
      type: String,
      default: 'Wybierz Mikroserwer'
    },
    selectedItemToText: {
      type: Function,
      default: (item) => item.identifier
    }
    // listApi: {
    //   type: Function,
    //   default: api.autocomplete
    // }
  },
  methods: {
    c: console.log,
    async listApi(search, params) {
      return [{id: 1, label: "TDL V1"}, {id: 3, label: "TDL V2 RED"}];
    }
  }
};
</script>

<style scoped></style>
